<template>
    <b-badge :variant="variant">{{ row.FuelTypeName }}</b-badge>
</template>

<script>
import { BBadge } from "bootstrap-vue";

export default {
    name: "FuelTypeBadge",
    components: { BBadge },
    props: {
        row: {
            type: Object,
            required: true,
        },
    },
    computed: {
        variant() {
            const name = (this.row.FuelTypeName || "").toLowerCase();

            if (name.includes("adblue")) {
                return "primary";
            }
            if (name.includes("motorin")) {
                return "warning";
            }
            return "secondary";
        },
    },
};
</script>
